/**
 * Runs the steps in order, each in a task of its own, so that starting a
 * page's widgets never holds the main thread long enough to delay a tap
 * (Total Blocking Time counts every task over 50 ms). The next step is
 * queued before one runs, so a step that throws is reported and the rest
 * still run.
 */
export function inTurn(
  steps: readonly (() => void)[],
  later: (run: () => void) => void = (run) => setTimeout(run, 0),
): void {
  let i = 0;
  const next = (): void => {
    if (i >= steps.length) return;
    const step = steps[i++];
    if (i < steps.length) later(next);
    step();
  };
  next();
}
